import {
  postNotifications,
  postMarkOldNotifications,
  NotificationResponse
} from '../../services/endpoints/notifications'
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import { NetworkRequestError } from '../../services/lib'
import { DefaultState } from '../../types'
import { processError } from '../lib/errors'

const sliceName = 'notifications'

export interface NotificationsState {
  notificationObj: NotificationResponse
  markOld: string
  notificationData: NotificationData
  loading: boolean
  error: NetworkRequestError | null
}

export interface NotificationData {
  unreadNotificationCounter: number
  highestNewNotificationId: number
}

export const checkNotifications = createAsyncThunk(
  `${sliceName}/notifications`,
  async (_, { rejectWithValue, getState, dispatch }) => {
    const state = getState() as DefaultState //note, I hate doing this
    try{
      return await postNotifications(
        state.notifications.notificationData.unreadNotificationCounter,
        state.notifications.notificationData.highestNewNotificationId
      )
    } catch (err: unknown) {
      return rejectWithValue(processError(err, dispatch))
    }
  }
)

export const markOldNotifications = createAsyncThunk(
  `${sliceName}/markOld`,
  async (_, { rejectWithValue, dispatch }) => {
    const id = parseInt(window.sessionStorage.getItem('highestNewNotificationId') || '') || 0
    try {
      return await postMarkOldNotifications(id)
    } catch (err: unknown) {
      return rejectWithValue(processError(err, dispatch))
    }
  }
)

export const initialNotificationsState: NotificationsState = {
  notificationObj: { newNotifications: [], numOfUnreadNotifications: 0 },
  notificationData: {  unreadNotificationCounter: 0, highestNewNotificationId: 0},
  loading: false,
  error: null,
  markOld: ''
}

export const notificationsSlice = createSlice({
  name: sliceName,
  initialState: initialNotificationsState,
  reducers: {
  },
  extraReducers(builder) {
    builder
      .addCase(
        checkNotifications.fulfilled,
        (state, action) => {
          // 204 successful responses return 'null'. Don't update state if the payload is null
          if(action.payload) {
            state.notificationObj.numOfUnreadNotifications = action.payload.numOfUnreadNotifications
            state.notificationObj.newNotifications = action.payload.newNotifications
            state.notificationData.unreadNotificationCounter = action.payload.numOfUnreadNotifications
            state.notificationData.highestNewNotificationId = action.payload.newNotifications.length > 0 ? Math.max(...action.payload.newNotifications.map(o=>o.id)) : 0
          }
          state.error = null  
          state.loading = false
        }
      )
      .addCase(checkNotifications.pending, (state, _action) => {
        state.loading = true
      })
      .addCase(checkNotifications.rejected, (state, action) => {
        state.error = action.payload as NetworkRequestError
        state.loading = false
      })

      .addCase(
        markOldNotifications.fulfilled,
        (state, action: PayloadAction<string>) => {
          state.markOld = action.payload
          state.error = null
          state.loading = false
        }
      )
      .addCase(markOldNotifications.pending, (state, _action) => {
        state.loading = true
      })
      .addCase(markOldNotifications.rejected, (state, action) => {
        state.error = action.payload as NetworkRequestError
        state.loading = false
      })
  },
})
